import { get, toLower } from "lodash";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import TimesheetTable from "./TimesheetTable";
import { useDispatch, useSelector } from "react-redux";
import { langDate, langMonth } from "../../utils/properties";
import Filter from "../../components/functional_components/Filter/Filter";
import { useLocation, useParams } from "react-router-dom";
import { setSection } from "../../redux/ducks/Section";
import { useTranslation } from "react-i18next";
import TimesheetPortal from "../../services/api/TimesheetPortal";
import { setLoading } from "../../redux/ducks/Loading";
import { showError } from "../../utils/utilities";
import dayjs from "dayjs";

const TimesheetDetail = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const dateFormat = langMonth[toLower(currentLanguage)];
  const [state, setState] = useState({
    filterData: null,
    month: dayjs().format("YYYYMM"),
  });
  useEffect(() => {
    // getMonth();
    if (params.id) {
      dispatch(setSection({ section: { title: `${location.state.userName} ${location.state.userSurname}` } }));
    }
  }, [params.id, location.state, dispatch]);

  useEffect(() => {
    getMonth();
  }, []);

  const getMonth = async () => {
    dispatch(setLoading(true));
    const data = await TimesheetPortal.getMonth();
    if (!data.error) {
      const dataStr = String(data);
      const parsedDate = dayjs(dataStr).format("YYYYMM");
      // Aggiorna lo stato solo se necessario per impedire il loop infinito
      if (state.month !== dataStr || state.filterData !== parsedDate) {
        setState((prevState) => ({
          ...prevState,
          month: dataStr,
          filterData: parsedDate,
        }));
      }
    } else {
      showError(get(data, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const formikFilter = useFormik({
    initialValues: {
      month: dayjs(state.month, "YYYYMM"),
    },
    validate: (values) => {
      let errors = {};
      if (!values.month) errors.month = "Required!";
      return errors;
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      const month = dayjs(values.month).format("YYYYMM");
      setState((prevState) => ({ ...prevState, filterData: month }));
    },
  });

  const fieldsFilter = [
    {
      type: "month",
      isRequired: true,
      id: "month",
      name: "month",
      format: dateFormat,
      locale: langDate[`locale_${toLower(currentLanguage)}`],
      label: t("timesheet.filter.month"),
      value: formikFilter.values.month,
      onChange: (date) => {
        formikFilter.setFieldValue("month", date);
      },
    },
  ];

  return (
    <>
      <Filter
        formikForm={formikFilter}
        fields={fieldsFilter}
        allInOneRow={false}
        onReset={() =>
          setState((prevState) => ({
            ...prevState,
            filterData: dayjs(state.month).format("YYYYMM"),
          }))
        }
      />
      {state.filterData && <TimesheetTable filterData={state.filterData} currentMonth={state.month} />}
    </>
  );
};

export default TimesheetDetail;
